export const KIOSK_CRYPTO = {
  bitcoin: 'btc',
  ethereum: 'eth'
};
